import { render, staticRenderFns } from "./AwardName.vue?vue&type=template&id=2f8c47bc&scoped=true&"
import script from "./AwardName.vue?vue&type=script&lang=js&"
export * from "./AwardName.vue?vue&type=script&lang=js&"
import style0 from "./AwardName.vue?vue&type=style&index=0&id=2f8c47bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c47bc",
  null
  
)

export default component.exports